import { CopyOutlined, RollbackOutlined, TeamOutlined } from '@ant-design/icons'
import { usePartners } from '@entities/partner'
import { dateToString } from '@shared/lib/dateToString/dateToString'
import type { TabsProps } from 'antd'
import { App, Avatar, Button, Card, Col, Divider, Flex, Input, Rate, Row, Space, Tabs, Typography } from 'antd'
import { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdvertisingPlatforms } from './advertising-platforms'
import { MainForm } from './main-form'
import { OrdForm } from './ord-form'
const { Title, Text } = Typography

export const EditPartnerPage = () => {
    const navigate = useNavigate()

    const { message } = App.useApp()

    const { id } = useParams<{ id: string }>()

    const partnerId = id ? parseInt(id) : undefined

    const {
        currentPartner,
        isLinkedPartner,
        actions: { editPartner, unlinkPartner }
    } = usePartners({ id: partnerId })

    const targetPartner = useMemo(
        () => (currentPartner?.linkedPartner ? currentPartner?.linkedPartner : currentPartner),
        [currentPartner]
    )

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Основная информация',
            children: targetPartner ? <MainForm partner={targetPartner} isLinkedPartner={isLinkedPartner} /> : undefined
        },
        {
            key: '2',
            label: 'Рекламные ресурсы',
            children: targetPartner ? (
                <AdvertisingPlatforms partner={targetPartner} isLinkedPartner={isLinkedPartner} />
            ) : undefined
        },
        {
            key: '3',
            label: 'ОРД',
            children: targetPartner ? <OrdForm partner={targetPartner} isLinkedPartner={isLinkedPartner} /> : undefined
        }
    ]

    const [rating, setRating] = useState(0)

    return (
        <Card>
            <Flex justify="space-between" align="center" style={{ marginBottom: '16px' }}>
                <Title level={3}>Редактирование партнера</Title>
                <Button type="primary" onClick={() => navigate('/advertising/partners')}>
                    Назад <RollbackOutlined />
                </Button>
            </Flex>
            <Flex justify="space-between" align="center">
                <Space size={20} align="start">
                    <Avatar shape="circle" size={100} src={currentPartner?.photoUrl} />
                    <Flex vertical={true} gap={6}>
                        <Title level={4} style={{ margin: 0 }}>
                            {targetPartner?.name}
                        </Title>

                        <Text italic>{targetPartner?.tgUsername}</Text>

                        <Text>{targetPartner?.email}</Text>
                        <Text>{targetPartner?.phone}</Text>
                        <Space align="center">
                            <Rate
                                value={currentPartner?.rating || rating}
                                onChange={(val) => setRating(val)}
                                disabled={!!currentPartner?.rating}
                            />
                            {!currentPartner?.rating && (
                                <Button
                                    type="primary"
                                    onClick={() =>
                                        partnerId && editPartner({ id: partnerId, data: { ...currentPartner, rating } })
                                    }
                                >
                                    Оценить
                                </Button>
                            )}
                        </Space>
                    </Flex>
                </Space>
                <Flex vertical gap={16} align="flex-end">
                    <Text>
                        Добавлен {currentPartner?.createdAt ? dateToString(currentPartner?.createdAt) : undefined}
                    </Text>
                    <Row gutter={16} align={'middle'} justify={'end'}>
                        {currentPartner?.linkedPartnerId ? (
                            <Col span={24}>
                                <Space>
                                    Пользователь привязан к партнеру
                                    <Button
                                        type="primary"
                                        onClick={() =>
                                            partnerId &&
                                            unlinkPartner({
                                                partnerId
                                            })
                                        }
                                    >
                                        Отвязать
                                    </Button>
                                </Space>
                            </Col>
                        ) : (
                            <>
                                <Col span={'auto'}>
                                    <Space.Compact>
                                        <Input
                                            value={`Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`}
                                        />
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                navigator.clipboard
                                                    .writeText(
                                                        `Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`
                                                    )
                                                    .then(() => {
                                                        message.success('Скопировано в буфер обмена')
                                                    })
                                            }
                                        >
                                            <CopyOutlined />
                                        </Button>
                                    </Space.Compact>
                                </Col>
                                <Col span={12}>
                                    <Space>
                                        Создать связку с пользователем Telepaglan
                                        <Button
                                            type="primary"
                                            icon={<TeamOutlined />}
                                            onClick={() =>
                                                navigator.clipboard
                                                    .writeText(
                                                        `${window.location.origin}?partner_id=${currentPartner?.id}`
                                                    )
                                                    .then(() => {
                                                        message.success('Скопировано в буфер обмена')
                                                    })
                                            }
                                        />
                                    </Space>
                                </Col>
                            </>
                        )}
                    </Row>
                </Flex>
            </Flex>

            <Divider />
            <Tabs defaultActiveKey="1" items={items} />
        </Card>
    )
}
